export const admimMenu = [
  {
    title: 'Vouchers',
    path: '/page-under-construction',
    icon: 'fas fa-ticket-alt',
    subMenuCollapse: true,
    submenu: [
      {
        title: 'Purchased',
        path: '/voucher/lists',
        icon: 'far fa-money-bill-alt',
        subMenuCollapse: false,
        submenu: []
      },
      {
        title: 'Redeemed',
        path: '/voucher/redeemed',
        icon: 'fas fa-check-square',
        subMenuCollapse: false,
        submenu: []
      },
      {
        title: 'Archived',
        path: '/voucher/archived',
        icon: 'fas fa-archive',
        subMenuCollapse: false,
        submenu: []
      }
    ]
  },
  {
    title: 'Voucher Config',
    path: '/voucher/archived',
    icon: 'fas fa-cogs',
    subMenuCollapse: true,
    submenu: [
      {
        title: 'List Vouchers',
        path: '/vconfig/list',
        icon: 'far fa-list-alt',
        subMenuCollapse: false,
        submenu: []
      },
      {
        title: 'Add New Voucher',
        path: '/vconfig/add',
        icon: 'far fa-file',
        subMenuCollapse: false,
        submenu: []
      }
    ]
  },
  {
    title: 'Affiliate',
    path: '/affiliate/list',
    icon: 'fas fa-network-wired',
    subMenuCollapse: true,
    submenu: [
      {
        title: 'List Affiliates',
        path: '/affiliate/list',
        icon: 'far fa-list-alt',
        subMenuCollapse: false,
        submenu: []
      },
      {
        title: 'Add New Affiliate',
        path: '/affiliate/add',
        icon: 'fas fa-user-plus',
        subMenuCollapse: false,
        submenu: []
      }
    ]
  }
];



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/config/adminMenuConfig/admin.menu.ts